<div class="container-fluid">
    <div class="col-sm-3">
        <mat-form-field>
            <mat-label>Current Role:</mat-label>
            <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()">
                <mat-option *ngFor="let group of userGroups" [value]="group.groupId"
                >{{group.grpName}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="col-md-12 col-sm-12">
        <div class="card mar-top-15">
            <!--            <div class="card-header card-header-top">-->
            <!--            </div>-->
            <div class="card-body height-250" id="viewGrid">
                <angular-slickgrid gridId="grid1"
                                   [columnDefinitions]="columnDefinitions"
                                   [gridOptions]="gridOptions"
                                   (onAngularGridCreated)="angularGridReady($event)"
                                   [gridWidth]="3000"
                                   (sgOnClick)="onCellClicked($event.detail.eventData, $event.detail.args)"
                                   [dataset]="dataset">
                </angular-slickgrid>
            </div>
        </div>
    </div>
</div>
<div *ngIf="displayIMS">
    <div *ngIf="displayCr">
        <app-display-ticket-cr
                [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                [groupName]="groupName"
                [grpLevel]="grpLevel" [notifier]="notifier"
                [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket">
        </app-display-ticket-cr>
    </div>
    <div *ngIf="displayPr">
        <app-display-ticket-pr
                [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                [groupName]="groupName"
                [grpLevel]="grpLevel" [notifier]="notifier"
                [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket">
        </app-display-ticket-pr>
    </div>
    <div *ngIf="displayCit">
        <app-display-ticket-cit [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                                [groupName]="groupName"
                                [grpLevel]="grpLevel" [notifier]="notifier"
                                [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket">
        </app-display-ticket-cit>
    </div>
</div>
<div *ngIf="displayAPPS">
    <div *ngIf="displayCr">
        <app-display-ticket-citapp-cr
                [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                [groupName]="groupName"
                [grpLevel]="grpLevel" [notifier]="notifier"
                [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket">
        </app-display-ticket-citapp-cr>
    </div>
    <div *ngIf="displayPr">
        <app-display-ticket-pr
                [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                [groupName]="groupName"
                [grpLevel]="grpLevel" [notifier]="notifier"
                [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket">
        </app-display-ticket-pr>
    </div>
    <div *ngIf="displayCit">
        <app-display-ticket-cit-apps [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                                     [groupName]="groupName"
                                     [grpLevel]="grpLevel" [notifier]="notifier"
                                     [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket"
        >
        </app-display-ticket-cit-apps>
    </div>
</div>
<div *ngIf="displayCHR">
    <app-display-ticket-chr [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
                            [groupName]="groupName"
                            [grpLevel]="grpLevel" [notifier]="notifier"
                            [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket"
    ></app-display-ticket-chr>

</div>
<div *ngIf="displaySSC">
    <app-modal [typeChecked]="typeChecked" [clientId]="clientId" [userGroupId]="userGroupSelected"
               [groupName]="groupName"
               [grpLevel]="grpLevel" [notifier]="notifier"
               [seq]="seq" [inciId]="inciId" [isViewTicket]="isViewTicket"></app-modal>
</div>
<notifier-container></notifier-container>

